import { getInvestorApiUrl } from "../../utils/config";
import { ApiRequestParams, handleFetchApi } from "../../utils/api";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";

interface MenuItem {
  componentName: string;
  iconId: number;
  id: number;
  imageUrl: string;
  menuName: string;
  navigationUrl: string;
  orderNo: number;
  parentId: number;
}

interface InitialState {
  isOpen: boolean;
  activeId: number;
  isFirstTime: boolean;
  loading: boolean;
  error: null;
  menuItems: MenuItem[];
}

const initialState: InitialState = {
  isOpen: true,
  activeId: 1,
  isFirstTime: true,
  loading: false,
  error: null,
  menuItems: [],
};

export const leftDrawerMenu = createAsyncThunk(
  "leftDrawerMenu/fetchleftDrawerMenu",
  async () => {
    try {
      const params: ApiRequestParams = {
        baseUrl: getInvestorApiUrl(),
        endpoint: `menu?componentName=investor`,
      };
      const response = await handleFetchApi(params);
      return response.data;
    } catch (error: any) {
      console.error("Error fetching data:", error?.message || error);
      return null;
    }
  }
);

const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    openMenuBar: (state) => {
      console.log(true, "redux");
      state.isOpen = true;
    },
    closeMenuBar: (state) => {
      console.log(false, "redux");
      state.isOpen = false;
    },
    firstTimeClosingMenuBar: (state) => {
      console.log("isFirstTime", false);
      state.isOpen = false;
      state.isFirstTime = false;
    },
    openLiveAuction: (state, action) => {
      console.log(true, "isFirstTime");
      state.isFirstTime = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(leftDrawerMenu.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(leftDrawerMenu.fulfilled, (state, action: any) => {
        state.loading = false;
        state.menuItems = action.payload;
      })
      .addCase(leftDrawerMenu.rejected, (state, action: any) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
/// export all the actions
export const {
  openMenuBar,
  closeMenuBar,
  firstTimeClosingMenuBar,
  openLiveAuction,
} = menuSlice.actions;
export default menuSlice.reducer;
